/* eslint-disable */
import { produce } from "immer";
import {
  FAQ_FETCH_FAILURE,
  FAQ_FETCH_SUCCESS,
  FAQ_FETCH_START,
} from "../actions/types";

const faqIllustration = (
  state = {
    faqIllustrationFetching: false,
    faqIllustrationData: [],
    faqIllustrationError: null,
  },
  action,
) => {
  switch (action.type) {
    case FAQ_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case FAQ_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case FAQ_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default faqIllustration;
